import { Dialog, DialogContent, IconButton } from "@mui/material";
import React from "react";
import RateAppointment from "../../../../pages/participant/rateAppointment";
import { AppointmentsParticipantContext } from "../context/appointmentsParticipantContext";
import { IRating } from "../interface/iRating";
import CloseIcon from "@mui/icons-material/Close";
import { Appointment } from "../../../../context/appContext";

const RateAppointmentDialog = (): React.JSX.Element => {
  const {
    rating,
    setRating,
  }: {
    rating: IRating;
    setRating: React.Dispatch<React.SetStateAction<IRating>>;
  } = React.useContext(AppointmentsParticipantContext);

  const handleClose = (): void =>
    setRating({ open: false, appointment: {} as Appointment });

  return (
    <React.Fragment>
      {rating.open && (
        <Dialog
          fullScreen
          open={rating.open}
          onClose={handleClose}
          aria-labelledby="rate-appointment-dialog-title"
          aria-describedby="rate-appointment-dialog-description"
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon
              sx={(theme) => ({
                fontSize: 30,
                color: theme.palette.grey[500],
              })}
            />
          </IconButton>

          <DialogContent>
            <RateAppointment />
          </DialogContent>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default RateAppointmentDialog;
